import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Container, Form, Spinner } from "react-bootstrap";
import { Wallet2 } from "iconsax-react";

import { ROUTE_MY_EXPERIMENT, ROUTE_SIM } from "../../../../routes";

import rocket_big from "../../../../image/purchase/rocket-big.png";
import rocket_medium from "../../../../image/purchase/rocket-medium.png";
import rocket_small from "../../../../image/purchase/rocket-small.png";
import {
  cartApi,
  checkDiscountApi,
  finalizePaymentApi,
} from "../../../../utility/api/apiList";

import {
  showDangerAlert,
  showSuccessAlert,
} from "../../../../redux/actions/alert/alertActions";

import useAxios from "../../../../hooks/useAxios";

import PaymentTableComponent from "./paymentTable";
import LayoutPurchaseComponent from "../layoutPurchase";
import PersonalPurchaseCardComponent from "../personalPurchase/cards";
import SecondaryButtonComponent from "../secondaryButton";
import ButtonComponent from "../../button";
import PurchaseSwitchComponent from "../switch/styledPurchaseSwitch";
import InputComponent from "../../form/input";

import {
  Wrapper,
  PurchaseInformation,
  StyledWalletData,
} from "../../../../containers/purchase/payment/styledPaymentPage";

const PersonalAndGroupPayment = ({
  cartResponse,
  walletResponse,
  salesPackageResponse,
  unitOfTime,
  simID,
}) => {
  const [productList, setProductList] = useState([]);
  const [isLoadingButton, setIsLoadingButton] = useState(false);

  const [price, setPrice] = useState({
    totalPrice: "",
    totalRawPrice: "",
    totalTax: "",
    finalDiscountPrice: "",
  });
  const [isInventionCode, setIsInventionCode] = useState(false);
  const [cartId, setCartId] = useState("");

  const [discountstate, setDiscountstate] = useState({
    discountId: "",
    discountValue: "",
    isAcceptDisCount: false,
  });
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [payWithWallet, setPayWithWallet] = useState({
    priceAfterPayWithWallet: 0,
    walletBalanceAfterPurchase: 0,
    decreaseFromWallet: 0,
  });

  const [isLoadingPaymentbtn, setIsLoadingPaymentbtn] = useState(false);
  //update cart price
  const [isLoadingCartPrice, setIsLoadingCartPrice] = useState(false);
  const [packagePersonalPurchaseList, setPackagePersonalPurchaseList] = useState([]);

  const companyDetail = useSelector((state) => state.companyDetail);
  const user = useSelector((state) => state.userDetail);

  const totalWalletBalance = walletResponse?.results.reduce(
    (accumulator, currentValue) => accumulator + currentValue.balance,
    0
  );

  const history = useHistory();
  const dispatch = useDispatch();

  const schema = yup.object().shape({
    discount_input: yup.string().required(),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { run: getCartDataRun } = useAxios({ url: cartApi });

  const { run: checkDiscountRun } = useAxios({
    url: `${checkDiscountApi}${discountstate.discountValue}`,
  });

  //post
  const { run: postDataToCartRun } = useAxios({
    url: cartApi,
    method: "post",
  });
  const { run: postCancelDataToCartRun } = useAxios({
    url: cartApi,
    method: "post",
  });
  const { run: finalizePaymentRun } = useAxios({
    url: finalizePaymentApi,
    method: "post",
  });

  const imageList = [
    { id: 12, name: rocket_big },
    { id: 6, name: rocket_medium },
    { id: 3, name: rocket_small },
  ];

  useEffect(() => {
    if (!user.isLogin) {
      dispatch(showDangerAlert("برای مشاهده جزئیات خرید لطفا ابتدا وارد شوید"));
    } else {
      setPackagePersonalPurchaseList(salesPackageResponse?.results);
      setPrice({
        ...price,
        totalPrice: cartResponse?.total_price,
        totalRawPrice: cartResponse?.total_raw_price,
      });
      setCartId(cartResponse?.cart_id);
      if (!cartResponse?.data[0].unitoftime.id) {
        //personal
        setProductList(cartResponse);
        setPrice({
          totalPrice: cartResponse?.total_price,
          totalRawPrice: cartResponse?.total_raw_price,
          finalDiscountPrice: cartResponse?.total_discount,
          totalTax: cartResponse?.total_tax,
        });
      } else {
        //company
        let productData = cartResponse;

        let finalProductArray = [];
        for (let index = 0; index < Object.keys(productData.data).length; index++) {
          const newElemment = {
            grade: productData.data[index].grade.id,
            gradeName: productData.data[index].grade.name,
            number: productData.data[index].count,
            dateId: productData.data[index].unitoftime.id,
            unitOfTimeName: productData.data[index].unitoftime.name,
            discount: productData.data[index].discount,
            priceWithNoDiscount: productData.data[index].raw_price,
            totalPrice: productData.data[index].total_price,
          };
          finalProductArray.push(newElemment);
        }
        setPrice({
          finalDiscountPrice: productData.total_discount,
          totalPrice: productData.total_price,
          totalRawPrice: productData.total_raw_price,
          totalTax: productData.total_tax,
        });
        setProductList(finalProductArray);
      }
    }
  }, []);

  useEffect(() => {
    handlePriceWithPayment();
  }, [discountstate.isAcceptDisCount]);

  useEffect(() => {
    if (discountstate.discountValue) {
      setIsLoadingButton(true);
      checkDiscountRun()
        .then((response) => {
          setIsLoadingCartPrice(true);
          let dataForPostCart = [];
          let data = {};
          if (response.data.id) {
            setDiscountstate({
              ...discountstate,
              discountId: response.data.id,
            });

            setIsInventionCode(false);
            setTimeout(() => {
              setIsLoadingButton(false);
              setDiscountstate({
                ...discountstate,
                isAcceptDisCount: true,
              });
              const priceShouldCalculate =
                price.totalPrice - price.finalDiscountPrice;
              if (priceShouldCalculate < response.data.min_purchase) {
                dispatch(
                  showDangerAlert(
                    `   حداقل مبلغ خرید برای اعمال تخفیف باید ${response.data.min_purchase.toLocaleString()}  تومان باشد`
                  )
                );
              } else {
                dispatch(showSuccessAlert("تخفیف با موفقیت اعمال شد"));
              }
              if (priceShouldCalculate >= response.data.min_purchase) {
                const disCountPrice =
                  (priceShouldCalculate * response.data.percent) / 100;
                if (disCountPrice <= response.data.max_discount) {
                } else {
                  showSuccessAlert(
                    `تخفیف با موفقیت اعمال شد . حداکثر مبلغ تخفیف ${response.data.max_discount.toLocaleString()} خواهد بود`
                  );
                }
              }
            }, 500);

            data = {
              discount_id: response.data.id,
              data: dataForPostCart,
            };
          } else {
            setIsInventionCode(true);
            setDiscountstate({
              ...discountstate,
              discountId: discountstate.discountValue,
            });
            dispatch(showSuccessAlert("تخفیف با موفقیت اعمال شد"));
            setIsLoadingButton(false);
            setDiscountstate({
              ...discountstate,
              isAcceptDisCount: true,
            });
            data = {
              invitation_code: discountstate.discountValue,
              data: dataForPostCart,
            };
          }

          if (!unitOfTime) {
            dataForPostCart.push({
              grade: productList.data[0].grade.id,
              count: productList.data[0].count,
              unitoftime: null,
              salespackage: productList.data[0].salespackage.id,
            });
          } else {
            for (let index = 0; index < Object.keys(productList).length; index++) {
              dataForPostCart.push({
                grade: productList[index].grade,
                count: productList[index].number,
                unitoftime: productList[index].dateId,
                salespackage: null,
              });
            }
          }

          postDataToCartRun(data)
            .then(() => {
              getCartDataRun()
                .then((response) => {
                  setPrice({
                    totalPrice: response.data.total_price,
                    totalRawPrice: response.data.total_raw_price,
                    totalTax: response.data.total_tax,
                    finalDiscountPrice: response.data.total_discount,
                  });

                  setIsLoadingCartPrice(false);
                  setCartId(response.data.cart_id);
                })
                .catch(() => {
                  dispatch(
                    showDangerAlert("مشکلی پیش  آمده، لطفا بعدا دوباره امتحان کنید.")
                  );
                });
            })
            .catch(() => {
              dispatch(
                showDangerAlert("مشکلی پیش  آمده، لطفا بعدا دوباره امتحان کنید.")
              );
            });
        })
        .catch((error) => {
          setDiscountstate({
            ...discountstate,
            discountId: "",
          });
          setTimeout(() => {
            setIsLoadingButton(false);
            dispatch(
              showDangerAlert(
                error.response?.data.details
                  ? error.response?.data.details
                  : "کد تخفیف وارد شده نامعتبر است"
              )
            );
            setDiscountstate({
              ...discountstate,
              isAcceptDisCount: false,
            });
          }, 500);
        });
    }
  }, [discountstate.discountValue]);

  const handleDisCount = (e) => {
    setDiscountstate({
      ...discountstate,
      discountValue: e.discount_input.toUpperCase(),
    });
  };
  const handleChangeWallet = () => {
    setPaymentMethod((paymentMethod) => !paymentMethod);
    handlePriceWithPayment();
  };
  const handlesetNewDiscount = (e) => {
    e.preventDefault();
    let dataForPostCart = [];
    let data = {};
    setIsLoadingCartPrice(true);
    if (!unitOfTime) {
      dataForPostCart.push({
        grade: productList.data[0].grade.id,
        count: productList.data[0].count,
        unitoftime: null,
        salespackage: productList.data[0].salespackage.id,
      });
    } else {
      for (let index = 0; index < Object.keys(productList).length; index++) {
        dataForPostCart.push({
          grade: productList[index].grade,
          count: productList[index].number,
          unitoftime: productList[index].dateId,
          salespackage: null,
        });
      }
    }
    data = {
      data: dataForPostCart,
    };

    postCancelDataToCartRun(data)
      .then(() => {
        getCartDataRun()
          .then((response) => {
            if (unitOfTime) {
            }
            setPrice({
              ...price,
              totalPrice: response.data.total_price,
              totalRawPrice: response.data.total_raw_price,
              totalTax: response.data.total_tax,
              finalDiscountPrice: response.data.total_discount,
            });
            setDiscountstate({
              discountId: "",
              discountValue: "",
              isAcceptDisCount: false,
            });
            reset();
            setIsLoadingCartPrice(false);
            setCartId(response.data.cart_id);
          })
          .catch(() => {
            dispatch(
              showDangerAlert("مشکلی پیش  آمده، لطفا بعدا دوباره امتحان کنید.")
            );
          });
      })
      .catch(() => {
        dispatch(showDangerAlert("مشکلی پیش  آمده، لطفا بعدا دوباره امتحان کنید."));
      });
  };

  const handlePriceWithPayment = () => {
    let extandWallet = totalWalletBalance - price.totalPrice;
    if (extandWallet > 0) {
      setPayWithWallet({
        priceAfterPayWithWallet: 0,
        walletBalanceAfterPurchase: extandWallet.toLocaleString(),
        decreaseFromWallet: price.totalPrice?.toLocaleString(),
      });
    } else {
      setPayWithWallet({
        priceAfterPayWithWallet: price.totalPrice - totalWalletBalance,
        walletBalanceAfterPurchase: 0,
        decreaseFromWallet: totalWalletBalance,
      });
    }
  };
  const handlePayment = (e) => {
    e.preventDefault();
    setIsLoadingPaymentbtn(true);
    let validEducation = unitOfTime;
    let educationsId = unitOfTime ? companyDetail.companySelected.id : null;
    let validDiscount = discountstate.discountId !== "";
    let paymentData = {};

    if (validEducation && validDiscount) {
      if (isInventionCode) {
        paymentData = {
          payment_id: cartId,
          gateway_id: 1,
          educations_id: educationsId,
          invitation_code: discountstate.discountId,
        };
      } else {
        paymentData = {
          payment_id: cartId,
          gateway_id: 1,
          educations_id: educationsId,
          discount_id: discountstate.discountId,
        };
      }
    }
    if (validEducation && !validDiscount) {
      paymentData = {
        payment_id: cartId,
        gateway_id: 1,
        educations_id: educationsId,
      };
    }
    if (!validEducation && validDiscount) {
      if (isInventionCode) {
        paymentData = {
          payment_id: cartId,
          gateway_id: 1,
          educations_id: null,
          invitation_code: discountstate.discountId,
        };
      } else {
        paymentData = {
          payment_id: cartId,
          gateway_id: 1,
          educations_id: null,
          discount_id: discountstate.discountId,
        };
      }
    }
    if (!validEducation && !validDiscount) {
      paymentData = {
        payment_id: cartId,
        gateway_id: 1,
        educations_id: null,
      };
    }
    if (paymentMethod) {
      paymentData.wallet_payment = true;
    } else {
      paymentData.wallet_payment = false;
    }

    finalizePaymentRun(paymentData)
      .then((response) => {
        setTimeout(() => {
          if (response.data?.payment_url) {
            window.location = `${response.data.payment_url}`;
          } else {
            dispatch(showSuccessAlert(response.data.success));
            setTimeout(() => {
              if (simID) {
                history.push({
                  pathname: `${ROUTE_SIM}${simID}`,
                });
              } else {
                history.push({
                  pathname: `/${user.userRole}/${ROUTE_MY_EXPERIMENT}/`,
                });
              }
            }, 4000);
          }
        }, 500);
      })
      .catch(() => {
        setIsLoadingPaymentbtn(false);
        dispatch(
          showDangerAlert("اتفاقی رخ داده است لطفا دوباره از اول امتحان کنید.")
        );
      });
  };

  return (
    <LayoutPurchaseComponent
      cardTitle={unitOfTime ? "اشتراک گروهی" : "اشتراک شخصی"}
      rowClassName="w-100 flex-grow-1"
      $height="auto"
    >
      <Wrapper className="p-0 mt-2 mt-md-4 mx-auto">
        {!unitOfTime && (
          <span className="p-0">
            <>
              {productList.data?.map((item) => (
                <div key={`wrapper-${item.id}`}>
                  {packagePersonalPurchaseList.map((selectedPackage, index) => {
                    if (
                      item.salespackage.month_count == selectedPackage.month_count &&
                      item.grade.name == selectedPackage.grade.name
                    ) {
                      return (
                        <PersonalPurchaseCardComponent
                          classname="personal-card-payment justify-content-end mx-auto mx-md-0 mt-4 mt-sm-5"
                          key={index}
                          packageImage={imageList.map(
                            (image) =>
                              image.id === selectedPackage.month_count && (
                                <img
                                  src={image.name}
                                  alt="اشتراک ماهانه"
                                  className="roket-style image-fluid d-block mb-0 mb-md-3"
                                  key={image.id}
                                />
                              )
                          )}
                          showPriceAndDiscount={true}
                          haveDiscount={selectedPackage?.discount}
                          discountPercent={selectedPackage?.discount_percent}
                          monthCount={selectedPackage.month_count}
                          priceAfterDiscount={selectedPackage.discount?.toLocaleString()}
                          priceBeforeDiscount={selectedPackage.price?.toLocaleString()}
                          totalprice={selectedPackage.price?.toLocaleString()}
                        />
                      );
                    }
                  })}
                </div>
              ))}
            </>
          </span>
        )}
        <span className="p-0">
          <PurchaseInformation className="p-0 pt-4 pb-4 d-flex flex-column justify-content-center align-items-center">
            <>
              {unitOfTime ? (
                <>
                  {productList.map((item, index) => (
                    <Container className="text-center" key={`item${index}`}>
                      <h2>{item.unitOfTimeName}</h2>
                      <h3>
                        پایه {item.gradeName} - تعداد {item.number}
                      </h3>
                    </Container>
                  ))}
                </>
              ) : (
                <>
                  {productList.data?.map((item) => (
                    <Container key={item.grade.id} className="text-center">
                      <h2>بسته آموزشی پایۀ {item.grade.name}</h2>
                      <h3>
                        اشتراک&nbsp;{item.salespackage.month_count}
                        &nbsp;ماهه
                      </h3>
                    </Container>
                  ))}
                </>
              )}
              <Form
                className="discount-form-wrapper my-2"
                onSubmit={handleSubmit(handleDisCount)}
              >
                <Form.Label htmlFor="discountInput">
                  کد تخفیف را وارد کنید.
                </Form.Label>
                <InputComponent
                  type="text"
                  register={register("discount_input")}
                  autoComplete="off"
                  disabled={discountstate.isAcceptDisCount || !user.isLogin}
                  id="discountInput"
                  containerClass="discount-input"
                  className="text-uppercase"
                />
                <SecondaryButtonComponent
                  titleButton={
                    discountstate.isAcceptDisCount ? "لغو تخفیف" : "اعمال تخفیف"
                  }
                  buttonType="submit"
                  isDisabledButton={isLoadingButton || !isValid || !user.isLogin}
                  handleClickButton={
                    discountstate.isAcceptDisCount ? handlesetNewDiscount : undefined
                  }
                  buttonHeight="30px"
                  fontSize="10px"
                  wrapperButtonclassName="col-xs-6 col-smS-3 p-0 m-1"
                />
              </Form>
              <Container className="mx-auto">
                <PaymentTableComponent
                  isLoadingCartPrice={isLoadingCartPrice}
                  totalRawPrice={price.totalRawPrice.toLocaleString()}
                  finalDiscountPrice={price.finalDiscountPrice.toLocaleString()}
                  paymentMethod={paymentMethod}
                  walletBalanceData={payWithWallet.decreaseFromWallet}
                  totalTax={price.totalTax.toLocaleString()}
                  priceAfterPayWithWallet={payWithWallet.priceAfterPayWithWallet.toLocaleString()}
                  totalPrice={price.totalPrice.toLocaleString()}
                />
              </Container>
            </>
          </PurchaseInformation>
          <StyledWalletData className="mx-auto my-3 py-3 px-1 px-sm-3 d-flex justify-content-center justify-content-lg-between align-items-center">
            <span className="p-0 w-auto d-flex justify-content-center align-items-center">
              <PurchaseSwitchComponent
                onChange={handleChangeWallet}
                inputProps={{ "aria-label": "controlled" }}
                disabled={totalWalletBalance < 1 || !cartResponse}
              />
              <p className="d-inline m-0 mx-2">استفاده از موجودی کیف پول</p>
            </span>
            <span className="Wallet-balance p-0 w-auto mt-2 mt-md-0">
              <Wallet2
                size="40"
                color="var(--secondary-color)"
                variant="Bold"
                className="icon-result-title"
              />
              {paymentMethod ? (
                <>
                  {payWithWallet.walletBalanceAfterPurchase.toLocaleString()}
                  &nbsp;
                </>
              ) : (
                <>
                  {totalWalletBalance}
                  &nbsp;
                </>
              )}
              تومان
            </span>
          </StyledWalletData>
          <ButtonComponent
            type="submit"
            className="submit-payment-button w-100 mb-4 mb-md-2"
            disabled={!cartResponse || !user.isLogin}
            onClick={handlePayment}
          >
            {isLoadingPaymentbtn ? (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              ></Spinner>
            ) : (
              "پرداخت"
            )}
          </ButtonComponent>
        </span>
      </Wrapper>
    </LayoutPurchaseComponent>
  );
};

export default PersonalAndGroupPayment;
